import React from 'react'
import {
  CFImage,
  CFView,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import OrderPickupButton from './OrderPickupButton'
import ViewMenu from './ViewMenu'
import Header from './Header'
import {
  hero,
  heroText,
  logo,
  mobileHero,
  mobileHeroText,
  viewMenu2,
} from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          w="100%"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
          alignCenter
          justifyBetween
        >
          <Header />
          <CFView column center mb="15px">
            <CFView pulsate mb="10px">
              <OrderPickupButton />
            </CFView>
            <ViewMenu />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="690px"
          w="100%"
          image={`url(${hero}) 30% 0% / cover no-repeat`}
          boxShadow="1px 1px 3px rgba(0,0,0,.6)"
          zIndex={90}
          column
          justifyBetween
          alignStart
        >
          <Header />
          <CFView w="100%" row center textCenter h="50px" bg="#A00F0F">
            <CFImage
              src={heroText}
              w="100%"
              maxWidth="520px"
              alt="About"
              mr="10px"
            />
            <CFView mt="5px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
